import React from "react";
import {
  DefaultButton,
  IBasePickerSuggestionsProps,
  ITag,
  PrimaryButton,
  Stack,
  TagPicker,
  Text,
} from "office-ui-fabric-react";
import { Loading } from "../../../services/Loading";
import { API_URL, childrenGap } from "../../common/Constants";
import CustomDrawer from "../../common/CustomDrawer";
import { ToastContext } from "../../common/ToastProvider";
import { Formik, FormikErrors } from "formik";
import {
  getCemApprovedDcForCustomer,
  getDatacentersForACustomer,
  downloadCustomerReport
} from "../../../services/customers/CustomerService";
import { downloadFile, getToken } from "../../../services/UtilService";
import { ICustomers } from "../../../vm";
import moment from "moment";

export interface ManageDownloadReportDialogProps {
  handleClose: Function;
  //   customerId: string;
  datacenterId: string;
  customer: ICustomers;
  date: Date | string;
  downloadSingleReport: Function
}

const ManageDownloadReportDialog: React.FC<ManageDownloadReportDialogProps> = ({
  handleClose,
  //   customerId,
  datacenterId,
  customer,
  date,
  downloadSingleReport
}) => {
  //custom hooks
  const { showToast } = React.useContext(ToastContext);
  // local state
  const [isLoading, setLoading] = React.useState(false);
  const [state, setState] = React.useState({
    datacenterOptions: [],
    selectedDatacenter: [],
    obj: {
      datacenterIds: [],
    },
  } as {
    datacenterOptions: ITag[];
    selectedDatacenter: ITag[];
    obj: {
      datacenterIds: string[];
    };
  });

  // hooks
  React.useEffect(() => {
    const asyncFunc = async () => {
      await getDatacenterForCustomers();
    };
    asyncFunc();
  }, []);

  const getDatacenterForCustomers = async () => {
    setLoading(true);
    const result = await getCemApprovedDcForCustomer({
      customerId: customer._id as string,
    });
    if (result?.success) {
      let datacenterOptions: ITag[] = [];
      let selectedDatacenter: ITag[] = [];
      let datacenterIds: string[] = [];

      result.data.forEach((d) => {
        if (d._id === datacenterId) {
          selectedDatacenter.push({
            key: d._id as string,
            name: d.name,
          });
          datacenterIds.push(d._id);
        }
        datacenterOptions.push({
          key: d._id as string,
          name: d.name,
        });
      });
      setState({
        ...state,
        datacenterOptions,
        selectedDatacenter,
        obj: {
          datacenterIds,
        },
      });
    } else {
      showToast(result?.message || "Error while getting datacenters", "error");
    }
    setLoading(false);
  };

  const handleDialogClose = (isOpen: boolean) => {
    handleClose(isOpen);
  };

  const datacenterPickerSuggestionsProps: IBasePickerSuggestionsProps = {
    noResultsFoundText: "No datacenter found",
  };

  const filterSuggestedTags = (filterText: string, tagList: ITag[]): ITag[] => {
    let allDataCenterList = [...state.datacenterOptions];

    // state.selectedDatacenter.forEach((item) => {
    //   allDataCenterList = allDataCenterList.filter(
    //     (ele) => ele.key !== item.key
    //   );
    // });

    return filterText
      ? allDataCenterList.filter(
          (tag) =>
            tag.name.toLowerCase().indexOf(filterText.toLowerCase()) === 0 &&
            !listContainsTagList(tag, tagList)
        )
      : [];
  };

  const showAllTags = (selectedItems?: ITag[] | undefined) => {
    let allDataCenterList = [...state.datacenterOptions];

    return removeDuplicates(allDataCenterList, selectedItems);
  };

  function removeDuplicates(tagList: ITag[], tags?: ITag[]) {
    return tagList.filter((tag) => !listContainsTagList(tag, tags));
  }

  const listContainsTagList = (tag: ITag, tagList?: ITag[]) => {
    if (!tagList || !tagList.length || tagList.length === 0) {
      return false;
    }
    return tagList.some((compareTag) => compareTag.key === tag.key);
  };

 const b64toBlob = async (b64Data:any, contentType='', sliceSize=512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, {type: contentType});
    return blob;
  }

  const downloadReport = async (datacenterIds: string[]) => {
    const dcString = datacenterIds.join(",");
    setLoading(true);
    const result = await downloadCustomerReport({
      customerId:customer._id,
      date:moment(date).format("yyyy-MM-DD"),
      datacenterIds:dcString,
      isSendPayload:true
     });
    // const result = await fetch(
    //   `${API_URL}mor-reports?customerId=${customer._id}&date=${moment(
    //     date
    //   ).format("yyyy-MM-DD")}&datacenterIds=${dcString}&isSendPayload=true`,
    //   {
    //     method: "GET",
    //     headers: {
    //       at: getToken(),
    //     },
    //   }
    // );
    // const pptx = await result.blob();
    // const pptxFile = new Blob([pptx], {
    //   type:
    //     "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    // });
    // const pptxFileUrl = window.URL.createObjectURL(pptxFile);
    // var a: any = document.createElement("a");
    // // document.body.appendChild(a);
    // // a.style = 'display:none';
    // a.href = pptxFileUrl;
    // a.download = `${customer.name}.pptx`;
    // a.click();

    const pptxFile  = await b64toBlob(result.data,"application/vnd.openxmlformats-officedocument.presentationml.presentation");
    const pptxFileUrl = window.URL.createObjectURL(pptxFile);
    const downloadLink = document.createElement("a");
    const fileName = `${customer.name}.pptx`;
    downloadLink.href = pptxFileUrl;
    downloadLink.download = fileName;
    downloadLink.click();

    setLoading(false);
    handleDialogClose(false);
  };

  return (
    <React.Fragment>
      {isLoading && <Loading />}
      <CustomDrawer
        title={"Select Datacenter to Download Report"}
        handelOpen={true}
        onClose={() => handleDialogClose(false)}
      >
        <Stack tokens={childrenGap}>
          <Formik
            enableReinitialize
            initialValues={state.obj}
            validate={(values: any) => {
              let errors: FormikErrors<typeof state.obj> = {};
              if (values.datacenterIds.length < 1) {
                errors.datacenterIds = "Required";
              }
              return errors;
            }}
            onSubmit={async (values: any, { setSubmitting }) => {
              let obj = { ...values };
              if (obj.datacenterIds.length === 1) {
                downloadSingleReport();
              } else {
                downloadReport(obj.datacenterIds);
              }

              setSubmitting(false);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              setFieldValue,
            }) => (
              <form onSubmit={handleSubmit}>
                <Stack wrap tokens={childrenGap}>
                  <Stack.Item className="custom-picker">
                    <TagPicker
                      selectedItems={state.selectedDatacenter}
                      removeButtonAriaLabel="Remove"
                      onResolveSuggestions={filterSuggestedTags as any}
                      pickerSuggestionsProps={datacenterPickerSuggestionsProps}
                      onEmptyResolveSuggestions={showAllTags}
                      inputProps={{
                        placeholder: "Select a particular datacenter",
                      }}
                      onChange={(items: any) => {
                        let datacenterIds: string[] = [];
                        items.forEach((i: any) => {
                          datacenterIds.push(i.key);
                        });
                        setFieldValue("datacenterIds", datacenterIds);
                        setState({ ...state, selectedDatacenter: items });
                      }}
                    />
                    {errors.datacenterIds && touched.datacenterIds && (
                      <Text className="error-msg">{errors.datacenterIds}</Text>
                    )}
                  </Stack.Item>
                  <Stack.Item>
                    <Stack
                      horizontal
                      wrap
                      tokens={childrenGap}
                      horizontalAlign="end"
                    >
                      <DefaultButton
                        text="Cancel"
                        onClick={() => handleDialogClose(false)}
                        className="borderless-btn"
                      />
                      <PrimaryButton type="submit" text={"Download Report"} />
                    </Stack>
                  </Stack.Item>
                </Stack>
              </form>
            )}
          </Formik>
        </Stack>
      </CustomDrawer>
    </React.Fragment>
  );
};

export default ManageDownloadReportDialog;
